import { render, staticRenderFns } from "./rel-serv-plans.vue?vue&type=template&id=c97b48c8&scoped=true"
import script from "./rel-serv-plans.vue?vue&type=script&lang=js"
export * from "./rel-serv-plans.vue?vue&type=script&lang=js"
import style0 from "./rel-serv-plans.vue?vue&type=style&index=0&id=c97b48c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97b48c8",
  null
  
)

export default component.exports